import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightSearch'
})
export class HighlightSearchPipe implements PipeTransform {
  transform(value: string | undefined | null, args: string): string {
    if (!value) return '';
    if (!args || args.trim() === '') {
      return value;
    }

    // Split search query into individual tokens
    const searchTokens = args.trim().split(/\s+/).filter(t => t.length > 0);
    if (searchTokens.length === 0) return value;

    // Escape regex characters for each token and join them with OR
    const escapedTokens = searchTokens.map(token => token.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'));
    const regex = new RegExp(`(${escapedTokens.join('|')})`, 'gi');
    
    // Perform case-insensitive search and wrap matches in highlight class
    return value.replace(regex, '<span class="search-highlight">$1</span>');
  }
}
